import React from 'react';

const KitchenCountContext = React.createContext();

export default KitchenCountContext;
